export const ENV = {
  BACKEND_URL:
    process.env.REACT_APP_NODE_ENV === 'development'
      ? 'http://localhost:3001/v1'
      : 'https://api.spbexport.ru/v1',
};
